/**
 * LessonCard 관련 상수들
 * (기존 LessonCardViewModel의 static 상수 분리)
 */

export const MAX_PRESTUDY_TIME = 8 // 선행학습 기준시간 (분)
export const ALLOW_CHANGE_TIME = 60 * 60

/**
 * 레슨 상태 (영문)
 */
export const CLASS_STATUS = {
  RESERVED: 'RESERVED',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
  ABSENT: 'ABSENT',
  PRE_STUDY: 'PRE_STUDY',
  PRE_STUDY_COMPLETED: 'PRE_STUDY_COMPLETED',
  NOT_RESERVED: 'NOT_RESERVED',
} as const

/**
 * 레슨 상태 (한글 → 영문 매핑)
 */
export const CLASS_STATUS_KR_MAP = {
  예약: CLASS_STATUS.RESERVED,
  완료: CLASS_STATUS.COMPLETED,
  취소: CLASS_STATUS.CANCELED,
  불참: CLASS_STATUS.ABSENT,
  예습: CLASS_STATUS.PRE_STUDY,
  예습완료: CLASS_STATUS.PRE_STUDY_COMPLETED,
  미예약: CLASS_STATUS.NOT_RESERVED,
} as const

/**
 * 레슨 상태 매핑 (통합)
 */
export const CLASS_STATUS_MAP = {
  예약: 'RESERVED',
  완료: 'COMPLETED',
  취소: 'CANCELED',
  불참: 'ABSENT',
  예습: 'PRE_STUDY',
  예습완료: 'PRE_STUDY_COMPLETED',
  미예약: 'NOT_RESERVED',
  RESERVED: 'RESERVED',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
  ABSENT: 'ABSENT',
  PRE_STUDY: 'PRE_STUDY',
  PRE_STUDY_COMPLETED: 'PRE_STUDY_COMPLETED',
  NOT_RESERVED: 'NOT_RESERVED',
} as const

/**
 * 레슨 상태 (완료/예습 필요)
 */
export const LESSON_STATE = {
  COMPLETED: 'COMPLETED',
  PRESTUDY_REQUIRED: 'PRESTUDY_REQUIRED',
} as const

/**
 * 에러 메시지 매핑
 */
export const ERROR_MESSAGE_MAP = {
  CANNOT_BOOKING: 'CANNOT_BOOKING',
  NOT_ENOUGH_TICKET: 'NOT_ENOUGH_TICKET',
  DUPLICATE_BOOKING: 'DUPLICATE_BOOKING',
} as const

/**
 * API curriculum type 매핑
 */
export const API_CURRICULUM_TYPE_MAP = {
  TRIAL: 'PODO_TRIAL',
  TRIAL_1: 'PODO_TRIAL',
  TRIAL_2: 'PODO_TRIAL',
  RECENT: 'PODO_TRIAL',
  BUSINESS: 'PODO_BUSINESS',
  BASIC: 'PODO_BASIC',
  SMART_TALK: 'PODO_SMART_TALK',
} as const

/**
 * 타입 추출
 */
export type ClassStatus = (typeof CLASS_STATUS)[keyof typeof CLASS_STATUS]
export type LessonState = (typeof LESSON_STATE)[keyof typeof LESSON_STATE]
export type ErrorMessageKey = keyof typeof ERROR_MESSAGE_MAP
